'use client';

import TuneIcon from '@mui/icons-material/Tune';
import { Box, Button, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { DashboardTitleBar } from '../layout/DashboardTitleBar';
import TomsVendingDashboardCharts from '../toms-vending/TomsVendingDashboardCharts';
import TomsVendingRecentSiteVisitsSection from '../toms-vending/TomsVendingRecentSiteVisitsSection';

const TomsVendingDashboardPage: React.FC = () => {
  const { user } = useAuth();
  const unitName = user?.currentBusinessUnit?.name;

  return (
    <Box>
      <DashboardTitleBar unitName={unitName} />
      <Box sx={{ p: 3, pt: 0 }}>
        <Stack
          direction="row"
          flexWrap="wrap"
          useFlexGap
          spacing={1}
          sx={{ mb: 2, alignItems: 'center' }}
        >
          <Tooltip
            title="Set warehouse and machine quantities for any location. Changes are recorded as adjustment movements."
            arrow
            placement="bottom-start"
          >
            <Button
              component={RouterLink}
              to="/app/toms-vending/inventory/location-adjustment"
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<TuneIcon sx={{ fontSize: 18 }} />}
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderRadius: 2,
                py: 0.375,
                px: 1.25,
                boxShadow: 'none',
                '&:hover': { boxShadow: 'none' },
              }}
            >
              Location stock adjustment
            </Button>
          </Tooltip>
        </Stack>

        <TomsVendingRecentSiteVisitsSection />

        <TomsVendingDashboardCharts />
      </Box>
    </Box>
  );
};

export default TomsVendingDashboardPage;
